/**
 * Asynchronously loads the component for Home
 */

import { lazyLoad } from 'utils/loadable';

export const CallStatus = lazyLoad(
  () => import('./index'),
  module => module.default,
);
